import axios from 'axios';

/**
 * Single axios instance for the whole app.
 * - baseURL comes from REACT_APP_BACKEND_URL (defaults to the `/api` proxy).
 * - withCredentials so the httpOnly auth cookie is sent.
 * - a response interceptor surfaces 401s to a registered handler so the app
 *   can drop its "authenticated" state when the session expires.
 */
const client = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || '/api',
  withCredentials: true,
});

let onUnauthorized = null;

/** Register a callback invoked whenever the API returns 401. */
export const setUnauthorizedHandler = (fn) => {
  onUnauthorized = fn;
};

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && onUnauthorized) {
      onUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default client;
